import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Typography, TextField, Button, Container } from "@mui/material";
import { Trans } from "@lingui/react/macro";
import { useLingui } from "@lingui/react/macro";
import { useDealContext } from "@/contexts/DealContext";

const WelcomePage = () => {
  const navigate = useNavigate();
  const [dealName, setName] = useState("");
  const { setDealName } = useDealContext();
  const { t } = useLingui();
  const handleStart = () => {
    if (dealName.trim()) {
      setDealName(dealName);
      navigate("/upload");
    }
  };

  return (
    <Container maxWidth="sm" sx={{ textAlign: "left", mt: 8, backgroundColor: "white",
 }}>
      <Typography variant="h6" gutterBottom>
        <Trans>Document Processing with AI</Trans>
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        <Trans>
          Enter a short description of the deal to get started with.
          <small>(You can change it later)</small>
        </Trans>
      </Typography>
      <TextField
        label={t`Deal short description`}
        variant="outlined"
        fullWidth
        value={dealName}
        onChange={(e) => setName(e.target.value)}
        onKeyUp={(e) => {
          if (e.key === "Enter") {
            handleStart();
          }
        }}
        sx={{ mb: 3 }}
      />
      <Button variant="contained" color="primary" onClick={handleStart} disabled={!dealName.trim()}>
        <Trans>Start</Trans>
      </Button>
      <div
        style={{
          width: "100%",
          marginTop: "8px",
          marginBottom: "4px",
          fontSize: "0.8rem",
          bottom: 0,
        }}
      >
        <b>🧠 Smart Document processing</b>
        <br />
        Our system automatically extracts key information from your loan agreement using AI to save
        you time. <br />
        You remain in full control — you can review, edit, or update any data suggested by the AI.{" "}
        <br />
        🔒 For further details on data usage, residency, and sovereignty, please visit our support
        page.
      </div>
    </Container>
  );
};

export default WelcomePage;
